import { WalletContainer } from '@/features/advertising';

export default function AdsWalletPage() {
  return <WalletContainer />;
}
